import { PaymentNewPage } from "../../kits/payments/PaymentForm.jsx";
import { PaymentPage } from "../../kits/payments/PaymentPage.jsx";
import { PaymentsPage } from "../../kits/payments/PaymentsPage.jsx";
import { AwaitingPaymentCard, GroupPaymentsPanel, InvoicePaymentState, invoicePaymentActions } from "../../kits/payments/slots.jsx";
import { InvoiceScheduleCard, IssueInstallments, PartnerReceivablesSection, receivablesQuery } from "../../kits/payments/Schedule.jsx";
import { registerActions, registerNav, registerRoute, registerSlot, registerSlotPreload } from "../../core/slots.jsx";

/**
 * モジュール sales の画面の並び（../eigyouryoku/docs/09 §4.1）。部品を土台の差し込み口に並べるだけ。
 *   いまは入金（部品 payments、E1）。メニューは「請求書」のあと、ホームのカード、請求書の見出しの右（チップと、主なボタン・⋯ の項目＝#172）、案件の「入金」タブ。
 *   どれもモジュール sales が ON の会社だけに出る。営業力の会社も、2026-09-29 からは現場力の会社も既定で ON（OFF の会社はメニューにも画面にも出ない）
 */
export function registerSales(): void {
  registerNav({
    to: "/payments",
    label: "入金",
    module: "sales",
    after: "invoices",
    icon: (
      <>
        <rect x="2" y="6" width="20" height="12" rx="2" />
        <circle cx="12" cy="12" r="3" />
        <path d="M6 12h.01M18 12h.01" />
      </>
    ),
  });
  registerRoute({ path: "/payments", module: "sales", element: () => <PaymentsPage /> });
  registerRoute({ path: "/payments/new", module: "sales", element: () => <PaymentNewPage /> });
  registerRoute({ path: "/payments/:id", module: "sales", element: () => <PaymentPage /> });
  registerSlot("invoice.head", "sales", InvoicePaymentState);
  registerActions("invoice.head", "sales", invoicePaymentActions);
  registerSlot("home.cards", "sales", AwaitingPaymentCard);
  registerSlot("group.payments", "sales", GroupPaymentsPanel);
  // 分割払い（#267 3b）：請求書の「お支払い予定」・{customer}の「入金予定」（先読みして下の節をずらさない）
  registerSlot("invoice.schedule", "sales", InvoiceScheduleCard);
  registerSlot("invoice.issue", "sales", IssueInstallments);
  registerSlot("partner.receivables", "sales", PartnerReceivablesSection);
  registerSlotPreload("partner.receivables", "sales", (_me, { partnerId }, qc) => qc.ensureQueryData(receivablesQuery(partnerId)));
}
